<template>
  <div>
    <div class="w-100 d-flex flex-wrap flex-padding">
        <!-- <div class="d-center-start w-50 mb-3"><left-text leftText="联系人"/>{{storeInfo.contact}}</div>
        <div class="d-center-start w-50 mb-3"><left-text leftText="联系电话"/>{{storeInfo.mob}}</div> -->
        <div class="d-center-start w-50 mb-3"><left-text leftText="办公电话"/>{{storeInfo.tel}}</div>
        <div class="d-center-start w-50 mb-3"><left-text leftText="总机电话"/>{{storeInfo.travel_tel}}</div>
        <div class="d-center-start w-50 mb-3"><left-text leftText="总积分"/>{{storeInfo.score}}</div>
        <div class="d-center-start w-50 mb-3"><left-text leftText="可用余额"/>{{storeInfo.money/100 | formatMoney}} 元</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PurchaserInfo',
  components: {},
  props: {
    storeInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
  .flex-padding{
    padding: 18px;
    align-items: center;
 }
</style>
